import { useEffect, useState } from 'react';
import CustomInput from 'components/common/CustomInput';
import CustomButton from 'components/common/CustomButton';
import { useGetUser, userAtom } from 'atom/user';
import { ReactComponent as CheckOn } from 'assets/common/checkOn.svg'
import { ReactComponent as CheckOff } from 'assets/common/checkOff.svg'
import { useSetAtom } from 'jotai';
import { encrypt } from 'components/encryptDecrpt';
import { toast } from 'react-toastify';
import { jsonAxios } from 'components/axios';
import CountryData from 'data/country.json'
import { ReactComponent as Info } from 'assets/common/info.svg'
import NateOnGuideModal from 'components/common/modal/NateOnGuideModal';
import MyPageTemplate from 'components/template/MyPageTemplate';

const EditProfile = () => {
    const user = useGetUser();
    const setUser = useSetAtom(userAtom)
    const [privacy, setPrivacy] = useState<boolean>(false);
    const [marketing, setMarketing] = useState<boolean>(false);
    const [webhook, setWebhook] = useState<string>('');
    const [popOpen, setPopOpen] = useState<boolean>(false);
    useEffect(() => {
        init();
    }, [])

    const init = () => {
        jsonAxios.get('user/info').then(res => {
            if (res.data.code === 200) {
                setPrivacy(res.data.data.agreePrivacy)
                setMarketing(res.data.data.agreeMarketing)
                setWebhook(res.data.data.nateonUrl)
            }
        })
    }
    const convertCountry = (country: string) => {
        const filtered = CountryData.filter(arr => arr.id === country)
        return filtered[0]?.ko || ''
    }
    const saveChange = () => {
        const reqData = {
            nateonUrl: webhook,
            agreeMarketing: marketing,
            agreePrivacy: privacy
        }
        jsonAxios.post('user/personal', reqData).then((res) => {
            if (res.data.code === 200) {
                jsonAxios.get('user/info').then(res => {
                    if (res.data.code === 200) {
                        const newUser = user
                        newUser.agreeMarketing = res.data.data.agreeMarketing
                        newUser.agreePrivacy = res.data.data.agreePrivacy
                        newUser.companyInfo = res.data.data.companyInfo
                        setUser(encrypt(JSON.stringify(newUser)))
                        toast.success('정상적으로 저장되었습니다.');
                    }
                })
            }
            else {
                toast.error('저장에 실패했습니다.');
            }
        })
    }

    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='pt-10 tablet:pt-4 h-full min-h-dvh'>
                <div
                    className='bg-white hover:shadow-lg p-10 mobile:p-6 rounded-xl transition-all'
                >
                    <div className='flex flex-col gap-6 w-[530px] mobile:w-full'>
                        <div>
                            <div className='flex items-center gap-3 mb-3'>
                                <p className='font-semibold mobile:text-base text-2xl'>
                                    네이트온 웹훅
                                </p>
                                <Info
                                    className='cursor-pointer'
                                    onClick={() => setPopOpen(true)} />
                            </div>
                            <CustomInput
                                type='text'
                                placeholder='https://teamroom.nate.com/webhook/xxxxxxxx/xxxxxxxxxxxxxxxxxxxxxxxxx'
                                value={webhook}
                                onChange={(e) => setWebhook(e.target.value)}
                            />

                        </div>
                        <div>
                            <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                E-mail
                            </p>
                            <CustomInput
                                type='email'
                                placeholder=''
                                value={user.username ?? ''}
                                disabled
                            />
                        </div>
                        <div>
                            <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                소속국가
                            </p>
                            <CustomInput
                                type='text'
                                placeholder=''
                                value={convertCountry(user.regionCode)}
                                disabled
                            />
                        </div>
                        <div className='mb-10'>
                            <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                선택동의
                            </p>

                            <div className='bg-[#F8F8FA] mb-3 px-6 rounded-lg h-15 tablet:h-10'>
                                <label
                                    htmlFor='privacy'
                                    className={`flex justify-between items-center h-full ${user.isMaster ? 'cursor-pointer' : ''}`}>
                                    개인정보 마케팅 활용 동의

                                    {
                                        privacy ?
                                            <CheckOn className='tablet:w-6' /> :
                                            <CheckOff className='tablet:w-6' />
                                    }
                                    {
                                        user.isMaster &&
                                        <input
                                            className="hidden accent-primary"
                                            type="checkbox"
                                            id="privacy"
                                            checked={privacy}
                                            onChange={() => setPrivacy(p => !p)}
                                        />
                                    }
                                </label>
                            </div>
                            <div className='bg-[#F8F8FA] px-6 rounded-lg h-15 tablet:h-10'>
                                <label
                                    htmlFor='marketing'
                                    className={`flex justify-between items-center h-full ${user.isMaster ? 'cursor-pointer' : ''}`}>
                                    마케팅 정보 수신 동의

                                    {
                                        marketing ?
                                            <CheckOn className='tablet:w-6' /> :
                                            <CheckOff className='tablet:w-6' />
                                    }
                                    {
                                        user.isMaster &&
                                        <input
                                            className="hidden accent-primary"
                                            type="checkbox"
                                            id="marketing"
                                            checked={marketing}
                                            onChange={() => setMarketing(p => !p)}
                                        />
                                    }
                                </label>
                            </div>
                        </div>

                        <CustomButton
                            className='bg-primary'
                            title='저장'
                            onClick={saveChange}
                        />
                    </div>
                </div>
            </div>
            <NateOnGuideModal
                isOpen={popOpen}
                setIsOpen={setPopOpen}
            />
        </MyPageTemplate>
    )
}

export default EditProfile